import React, { useState } from "react";
import Modal from "react-modal";
import heroVideo from "../../assets/logoanimation.mp4";
import heroImgMobile from "../../assets/img/hero/img-mobile.jpg";
import cancelImg from "../../assets/img/cancel.svg";
import Index from "../../components/about/index";
import founder2 from "../../assets/founder2.jpg";
// Social media icons
import { FaInstagram, FaLinkedin, FaFacebook, FaBehance } from "react-icons/fa";
import Founder12 from "../Sub2/Founder12";

const heroContent = {
  heroVideo: heroVideo,
  heroMobileImage: heroImgMobile,
  heroTitleImage: "../../assets/img/hero/title-image.jpg", // Replace with actual image
  heroDesignationImage: "../../assets/img/hero/designation-image.jpg", // Replace with actual image
  heroDescriptionImage: "../../assets/img/hero/description-image.jpg", // Replace with actual image
  heroBtn: "Discover",
};

const Experience = () => {
  const [isOpen, setIsOpen] = useState(false);

  function toggleModalOne() {
    setIsOpen(!isOpen);
  }

  return (
    <>
      <div className="row home-details-container ">
        {/* Background Video for Large Screens */}
        <div
          className="col-lg-4 position-fixed d-none d-lg-block"
          style={{
            backgroundImage: `url(${heroContent.heroVideo})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            border: "none",
            borderRadius: "20px",
          }}
        ></div>

        <div className="col-12 col-lg-8 offset-lg-4 home-details text-center text-lg-start">
          <div>
            {/* Mobile Video */}
            <video
              autoPlay
              loop
              muted
              playsInline
              className="d-sm-block d-lg-none"
              style={{
                width: "300px",
                height: "300px",
                borderRadius: "20px",
                objectFit: "cover",
                border: "none",
              }}
            >
              <source src={heroVideo} type="video/mp4" />
            </video>

            {/* Flex Container for Vertical Alignment */}
            <div
              className="d-flex flex-column align-items-center align-items-lg-start"
              style={{
                gap: "26px", // Consistent vertical gap between elements
              }}
            >
              {/* Image Wrapper with Overlay */}
              <div
                style={{
                  position: "relative",
                  width: "170%", // Matches maxWidth of the image
                  borderRadius: "20px",
                  overflow: "hidden",
                }}
              >
                {/* Hero Title Image */}
                <img
                  src={founder2}
                  alt="Victory Cineworld"
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                  }}
                />
                {/* Overlay */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)", // Initial black overlay
                    transition: "background-color 0.3s ease", // Smooth transition
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      "rgba(0, 0, 0, 0.5)")
                  }
                ></div>
              </div>
            </div>

            {/* Button and Social Media Icons */}
            <div className="   mt-4" style={{ paddingLeft: "60px" }}>
              <button
                className="button"
                onClick={toggleModalOne}
                style={{ paddingRight: "70px" }}
              >
                <span className="button-text">{heroContent.heroBtn}</span>
                <span className="button-icon fa fa-arrow-right"></span>
              </button>

              {/* Social Media Icons */}
              <div className="social-icons ms-4 d-flex mt-3">
                <a
                  href="https://www.instagram.com/gauravcpawar?igsh=anFtOWV3c2Rnenpz"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-4"
                >
                  <FaInstagram size={24} color="gray" />
                </a>
                <a
                  href="https://www.linkedin.com/in/gaurav-pawar-635693141/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="me-4"
                >
                  <FaLinkedin size={24} color="gray" />
                </a>

                <a href="https://www.facebook.com/gaurav.pawar.3323" target="_blank" rel="noopener noreferrer">
                  <FaFacebook size={24} color="gray" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal
        isOpen={isOpen}
        onRequestClose={toggleModalOne}
        contentLabel="My dialog"
        className="custom-modal dark hero"
        overlayClassName="custom-overlay dark"
        closeTimeoutMS={500}
      >
        <div>
          <button className="close-modal" onClick={toggleModalOne}>
            <img src={cancelImg} alt="close icon" />
          </button>

          <div className="box_inner about">
            <div data-aos="fade-up" data-aos-duration="1200">
              <div className="title-section text-left text-sm-center">
                <h1>
                  Meet <span>Gaurav</span>
                </h1>
                <span className="title-bg">Resume</span>
              </div>
              <Founder12 />
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Experience;
